/* eslint-disable no-undef */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-useless-escape */
/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import Loader from "../Components/Loader";
import Footer from "../Components/Footer";
import Cookies from "js-cookie";

import "../Styles/ofislerimiz.css";
import {
  XCircle,
  CreditCard,
  Calendar,
  Home,
  Gift,
  Phone,
  AlertTriangle,
  RefreshCw,
  ArrowLeft,
} from "lucide-react";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let navigate = useNavigate();
    let params = useParams();
    let [searchParams] = useSearchParams();
    return <Component {...props} router={{ navigate, params, searchParams }} />;
  }

  return ComponentWithRouterProp;
}

class GiftCardPaymentFailure extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentData: {
        phone: "",
        amount: "",
        transactionId: "",
        date: "",
        errorMessage: "",
      },
      loading: false,
      error: null,
      isMobile: window.innerWidth <= 768,
    };
  }

  componentDidMount() {
    this.loadPaymentData();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  };

  loadPaymentData = () => {
    try {
      const searchParams = this.props.router.searchParams;

      const transactionId = searchParams.get("transactionId");
      const displayId = searchParams.get("displayId");
      const error = searchParams.get("error");
      const phone = searchParams.get("phone")
        ? decodeURIComponent(searchParams.get("phone"))
        : "";
      const amount = searchParams.get("amount");

      this.setState({
        paymentData: {
          transactionId: displayId || transactionId || "",
          internalTransactionId: transactionId || "",
          date: new Date().toLocaleDateString("tr-TR"),
          errorMessage: error
            ? decodeURIComponent(error)
            : "Ödeme işlemi başarısız oldu",
          phone: phone,
          amount: amount || "",
        },
        loading: false,
        error: null,
      });
    } catch (error) {
      console.error("URL parameter hatası:", error);
      this.setState({
        paymentData: {
          transactionId: "",
          internalTransactionId: "",
          date: new Date().toLocaleDateString("tr-TR"),
          errorMessage: "Ödeme işlemi başarısız oldu",
          phone: "",
          amount: "",
        },
        loading: false,
        error: null,
      });
    }
  };

  handleGoToHome = () => {
    this.props.router.navigate("/");
  };

  handleRetryPayment = () => {
    this.props.router.navigate("/register");
  };

  handleGoBack = () => {
    window.history.back();
  };

  formatPhoneNumber = (phone) => {
    if (!phone) return "";

    const cleanPhone = phone.trim().replace(/\s+/g, "");

    if (cleanPhone.startsWith("+90")) {
      return cleanPhone;
    }

    if (cleanPhone.startsWith("90")) {
      return "+" + cleanPhone;
    }

    if (cleanPhone.startsWith("0")) {
      return "+90" + cleanPhone.substring(1);
    }

    return "+90" + cleanPhone;
  };

  render() {
    const { paymentData, loading, error, isMobile } = this.state;
    const formattedPhone = this.formatPhoneNumber(paymentData.phone);

    if (loading) {
      return (
        <>
          <Loader />
          <SubHeader />
          <Header isLoggedIn={Cookies.get("token") == null ? false : true} />

          <div className="offices-container">
            <div
              className="container text-center"
              style={{ padding: isMobile ? "50px 0" : "100px 0" }}
            >
              <div
                className="spinner-border text-danger"
                role="status"
                style={{ 
                  width: isMobile ? "2rem" : "3rem", 
                  height: isMobile ? "2rem" : "3rem" 
                }}
              >
                <span className="sr-only">Yükleniyor...</span>
              </div>
              <h4 style={{ 
                marginTop: "20px", 
                color: "#666",
                fontSize: isMobile ? "16px" : "20px"
              }}>
                İşlem bilgileri yükleniyor...
              </h4>
            </div>
          </div>

          <Footer />
        </>
      );
    }

    return (
      <>
        <Loader />
        <SubHeader />
        <Header isLoggedIn={Cookies.get("token") == null ? false : true} />

        <div className="offices-container">
          <div
            className="offices-header"
            style={{
              background: "linear-gradient(135deg, #dc3545 0%, #f8d7da 100%)",
              padding: isMobile ? "40px 0" : "60px 0",
            }}
          >
            <div className="offices-header-pattern" />

            <div className="container offices-header-container">
              <div className="row">
                <div className="col-12" style={{ textAlign: "center" }}>
                  <div style={{ marginBottom: isMobile ? "15px" : "20px" }}>
                    <XCircle size={isMobile ? 60 : 80} color="white" />
                  </div>
                  <h6 className="offices-header-subtitle" style={{
                    fontSize: isMobile ? "12px" : "14px",
                    marginBottom: isMobile ? "10px" : "15px"
                  }}>
                    HEDİYE KODU SATIŞI
                  </h6>
                  <h1 className="offices-header-title" style={{
                    fontSize: isMobile ? "24px" : "36px",
                    marginBottom: isMobile ? "15px" : "20px"
                  }}>
                    Ödeme Başarısız Oldu
                  </h1>
                  <p className="offices-header-description" style={{
                    fontSize: isMobile ? "14px" : "16px",
                    lineHeight: "1.5",
                    padding: isMobile ? "0 10px" : "0"
                  }}>
                    Hediye kodu satın alma işleminiz tamamlanamadı. Lütfen
                    tekrar deneyiniz.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="offices-grid">
            <div className="container">
              <div className="row justify-content-center">
                <div className={isMobile ? "col-12" : "col-lg-10"}>
                  <div
                    className="office-card universal-card universal-shimmer"
                    style={{ 
                      marginBottom: isMobile ? "20px" : "40px",
                      margin: isMobile ? "10px" : "0 0 40px 0"
                    }}
                  >
                    <div className="office-card-pattern universal-pattern" />

                    <div
                      className="office-card-content"
                      style={{ padding: isMobile ? "20px 15px" : "40px" }}
                    >
                      <div
                        className="text-center"
                        style={{ marginBottom: isMobile ? "20px" : "30px" }}
                      >
                        <div
                          style={{
                            background:
                              "linear-gradient(135deg, #dc3545 0%, #f8d7da 100%)",
                            borderRadius: "50%",
                            width: isMobile ? "80px" : "100px",
                            height: isMobile ? "80px" : "100px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: isMobile ? "0 auto 15px" : "0 auto 20px",
                          }}
                        >
                          <XCircle size={isMobile ? 40 : 50} color="white" />
                        </div>
                        <h2 style={{ 
                          color: "#dc3545", 
                          marginBottom: "10px",
                          fontSize: isMobile ? "20px" : "28px"
                        }}>
                          Ödeme Başarısız Oldu
                        </h2>
                        {paymentData.transactionId && (
                          <p style={{ 
                            color: "#666", 
                            fontSize: isMobile ? "14px" : "16px",
                            wordBreak: "break-all"
                          }}>
                            İşlem ID:{" "}
                            <strong>{paymentData.transactionId}</strong>
                          </p>
                        )}
                      </div>

                      <div className="row">
                        <div className="col-md-12">
                          <div
                            className="office-info-card universal-card universal-shimmer"
                            style={{
                              marginBottom: "20px",
                              background: "#f8f9fa",
                            }}
                          >
                            <div
                              className="office-info-card-content"
                              style={{ padding: isMobile ? "15px" : "20px" }}
                            >
                              <h4
                                style={{
                                  color: "#333",
                                  marginBottom: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: isMobile ? "16px" : "18px"
                                }}
                              >
                                <CreditCard
                                  size={isMobile ? 18 : 20}
                                  style={{ marginRight: "10px" }}
                                />
                                İşlem Bilgileri
                              </h4>

                              <div className={isMobile ? "" : "row"}>
                                <div className={isMobile ? "" : "col-md-6"}>
                                  {paymentData.transactionId && (
                                    <div style={{ 
                                      marginBottom: "10px",
                                      fontSize: isMobile ? "13px" : "14px",
                                      wordBreak: "break-all"
                                    }}>
                                      <strong>İşlem ID:</strong>{" "}
                                      {paymentData.transactionId}
                                    </div>
                                  )}
                                  <div
                                    style={{
                                      marginBottom: "10px",
                                      display: "flex",
                                      alignItems: "center",
                                      fontSize: isMobile ? "13px" : "14px"
                                    }}
                                  >
                                    <Calendar
                                      size={isMobile ? 14 : 16}
                                      style={{ marginRight: "5px" }}
                                    />
                                    <strong>Tarih:</strong> {paymentData.date}
                                  </div>
                                  <div style={{ 
                                    marginBottom: isMobile ? "15px" : "10px",
                                    fontSize: isMobile ? "13px" : "14px"
                                  }}>
                                    <strong>Durum:</strong>
                                    <span
                                      style={{
                                        color: "#dc3545",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      ❌ Başarısız
                                    </span>
                                  </div>
                                </div>

                                <div className={isMobile ? "" : "col-md-6"}>
                                  {paymentData.amount && (
                                    <div style={{ 
                                      marginBottom: "10px",
                                      fontSize: isMobile ? "13px" : "14px"
                                    }}>
                                      <strong>Tutar:</strong>{" "}
                                      {paymentData.amount} TL
                                    </div>
                                  )}
                                  {paymentData.phone && (
                                    <div
                                      style={{
                                        marginBottom: "10px",
                                        display: "flex",
                                        alignItems: "center",
                                        fontSize: isMobile ? "13px" : "14px"
                                      }}
                                    >
                                      <Phone
                                        size={isMobile ? 14 : 16}
                                        style={{ marginRight: "5px" }}
                                      />
                                      <strong>Telefon:</strong>{" "}
                                      <span style={{ marginLeft: "5px" }}>
                                        {formattedPhone}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="office-warning-card universal-card universal-shimmer"
                        style={{
                          background: "#f8d7da",
                          border: "2px solid #dc3545",
                          borderRadius: "10px",
                          marginBottom: isMobile ? "20px" : "30px",
                        }}
                      >
                        <div
                          className="office-warning-card-content"
                          style={{ padding: isMobile ? "15px" : "25px" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              flexDirection: isMobile ? "column" : "row"
                            }}
                          >
                            <XCircle
                              size={isMobile ? 24 : 30}
                              color="#dc3545"
                              style={{
                                marginRight: isMobile ? "0" : "15px",
                                marginBottom: isMobile ? "10px" : "0",
                                marginTop: isMobile ? "0" : "5px",
                                flexShrink: 0,
                                alignSelf: isMobile ? "center" : "flex-start"
                              }}
                            />
                            <div style={{ textAlign: isMobile ? "center" : "left" }}>
                              <h4
                                style={{
                                  color: "#721c24",
                                  marginBottom: "15px",
                                  fontSize: isMobile ? "16px" : "20px",
                                }}
                              >
                                ÖDEME BAŞARISIZ OLDU
                              </h4>
                              <p
                                style={{
                                  color: "#721c24",
                                  marginBottom: "10px",
                                  fontSize: isMobile ? "14px" : "16px",
                                  lineHeight: "1.6",
                                }}
                              >
                                <strong>Hata:</strong>{" "}
                                {paymentData.errorMessage}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="office-info-card universal-card universal-shimmer"
                        style={{
                          marginBottom: isMobile ? "20px" : "30px",
                          background: "#fff3cd",
                          border: "1px solid #ffc107",
                        }}
                      >
                        <div
                          className="office-info-card-content"
                          style={{ padding: isMobile ? "15px" : "20px" }}
                        >
                          <h4
                            style={{
                              color: "#856404",
                              marginBottom: "15px",
                              display: "flex",
                              alignItems: "center",
                              fontSize: isMobile ? "16px" : "18px"
                            }}
                          >
                            <AlertTriangle
                              size={isMobile ? 18 : 20}
                              style={{ marginRight: "10px" }}
                            />
                            Ne Yapabilirsiniz?
                          </h4>
                          <ul
                            style={{
                              color: "#856404",
                              marginBottom: "0",
                              lineHeight: "1.6",
                              fontSize: isMobile ? "13px" : "14px",
                              paddingLeft: isMobile ? "15px" : "20px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word"
                            }}
                          >
                            <li style={{ marginBottom: "8px" }}>
                              Kart bilgilerinizi kontrol ederek tekrar deneyin
                            </li>
                            <li style={{ marginBottom: "8px" }}>
                              Kartınızın bakiyesinin yeterli olduğundan emin
                              olun
                            </li>
                            <li style={{ marginBottom: "8px" }}>İnternet bağlantınızı kontrol edin</li>
                            <li style={{ marginBottom: "8px" }}>
                              Farklı bir ödeme yöntemi ile tekrar
                              deneyebilirsiniz
                            </li>
                            <li style={{ marginBottom: "8" }}>
                              Sorun devam ederse müşteri hizmetlerimizle
                              iletişime geçin
                            </li>
                            <br />
                            <br />
                            <br />
                            <br />
                          </ul>
                        </div>
                      </div>

                      <div
                        className="text-center"
                        style={{ marginTop: isMobile ? "20px" : "30px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: isMobile ? "column" : "row",
                            flexWrap: isMobile ? "nowrap" : "wrap",
                            gap: isMobile ? "12px" : "15px",
                            alignItems: "center"
                          }}
                        >
                          <button
                            onClick={this.handleGoBack}
                            style={{
                              background: "#6c757d",
                              color: "white",
                              border: "none",
                              padding: isMobile ? "12px 20px" : "15px 30px",
                              borderRadius: "8px",
                              fontSize: isMobile ? "14px" : "16px",
                              fontWeight: "bold",
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              transition: "all 0.2s ease",
                              width: isMobile ? "100%" : "auto",
                              maxWidth: isMobile ? "280px" : "none"
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background = "#5a6268";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = "#6c757d";
                            }}
                          >
                            <ArrowLeft
                              size={isMobile ? 18 : 20}
                              style={{ marginRight: "10px" }}
                            />
                            Geri Dön
                          </button>

                          <button
                            onClick={this.handleRetryPayment}
                            style={{
                              background: "#dc3545",
                              color: "white",
                              border: "none",
                              padding: isMobile ? "12px 20px" : "15px 30px",
                              borderRadius: "8px",
                              fontSize: isMobile ? "14px" : "16px",
                              fontWeight: "bold",
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              transition: "all 0.2s ease",
                              width: isMobile ? "100%" : "auto",
                              maxWidth: isMobile ? "280px" : "none"
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background = "#c82333";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = "#dc3545";
                            }}
                          >
                            <RefreshCw
                              size={isMobile ? 18 : 20}
                              style={{ marginRight: "10px" }}
                            />
                            Tekrar Dene
                          </button>

                          <button
                            onClick={this.handleGoToHome}
                            style={{
                              background:
                                "linear-gradient(135deg, #007bff 0%, #0056b3 100%)",
                              color: "white",
                              border: "none",
                              padding: isMobile ? "12px 20px" : "15px 30px",
                              borderRadius: "8px",
                              fontSize: isMobile ? "14px" : "16px",
                              fontWeight: "bold",
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              transition: "all 0.2s ease",
                              width: isMobile ? "100%" : "auto",
                              maxWidth: isMobile ? "280px" : "none"
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.transform = "translateY(-2px)";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.transform = "translateY(0px)";
                            }}
                          >
                            <Home size={isMobile ? 18 : 20} style={{ marginRight: "10px" }} />
                            Ana Sayfaya Dön
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />

        <style jsx>{`
          @media (max-width: 768px) {
            .offices-container {
              margin: 0 !important;
              padding: 0 !important;
            }
            
            .container {
              padding-left: 10px !important;
              padding-right: 10px !important;
            }
            
            .office-card {
              margin: 10px !important;
              border-radius: 12px !important;
            }
            
            .offices-header {
              padding: 40px 0 !important;
            }
            
            .offices-header-title {
              font-size: 24px !important;
              line-height: 1.3 !important;
            }
            
            .offices-header-description {
              font-size: 14px !important;
              padding: 0 10px !important;
            }
          }
          
          @media (max-width: 480px) {
            .container {
              padding-left: 5px !important;
              padding-right: 5px !important;
            }
            
            .office-card-content {
              padding: 15px !important;
            }
            
            .offices-header {
              padding: 30px 0 !important;
            }
          }
          
          @media (max-width: 375px) {
            .office-card {
              margin: 5px !important;
            }
            
            .office-card-content {
              padding: 12px !important;
            }
          }
        `}</style>
      </>
    );
  }
}

export default withRouter(GiftCardPaymentFailure);